import styled from "styled-components";

interface ICongratsTextDefaultBoxProps {
    bigSize: boolean;
}

export const CongratsTextDefaultBox = styled.div<ICongratsTextDefaultBoxProps>`
    font-size: ${props => props.bigSize ? "1.4" : "0"}rem;
    @media ${props => props.theme.mediaQuery.lAndBelow} {
        font-size: ${props => props.bigSize ? "1.2" : "0"}rem;
    }
    line-height: 1.3;
    transition: all 0.4s ease-in;
    width: ${props => props.bigSize ? "18" : "0"}rem;
    padding: ${props => props.bigSize ? "0.8" : "0"}rem;
    padding-right: ${props => props.bigSize ? "1.6" : "0"}rem;
    padding-left: 0px;
    opacity: ${props => props.bigSize ? "1" : "0"};
`;